import React from 'react'
import { 
  Card, 
  Grid, 
  IconButton, 
  Typography, 
  useTheme
} from '@mui/material'
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import BookmarkAddOutlinedIcon from '@mui/icons-material/BookmarkAddOutlined';
import { useNavigate } from 'react-router-dom';

function RecipeListCardPreview({
  recipeTitle,
  id,
  imageSrc,
}) {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/edit-recipe-details/${id}`);
  };

  const handleBookmarkClick = () => {
    console.log('bookmarked');
  };

  const handleDownloadRecipe = () => {
    console.log('handledownload clicked');
  };

  return (
    <Card
      sx={{
        width: '100%',
        height: '8rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0.5rem',
        marginBottom: '1rem',
        flexShrink: 0
      }}
    >
      <Grid item sx={{ flex: '1', height: '100%', width: '5rem', marginRight: '1rem' }}>
        <img alt='recipe photo' src={imageSrc}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            borderRadius: '1rem',
          }}
        />
      </Grid>
      <Grid container sx={{ flex: '4', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', height: '100%' }}>
        <Grid item flex={'1'} display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
          <Typography variant='primary' fontWeight={700} fontSize={'1.25rem'}>
            {recipeTitle}
          </Typography>
        </Grid>
        <Grid item flex={'1'}>
          <IconButton
            height={50}
            width={50}
            sx={{ 
              color: `${theme.palette.primary.main}`,
              backgroundColor: `${theme.palette.secondary.main}`,
              marginRight: '1rem'
            }}
            onClick={handleEdit}
          >
            <OpenInFullOutlinedIcon />
          </IconButton>
          <IconButton
            height={50}
            width={50}
            sx={{ 
              color: `${theme.palette.primary.main}`,
              backgroundColor: `${theme.palette.secondary.main}`,
              marginRight: '1rem'
            }}
            onClick={handleDownloadRecipe}
          >
            <DownloadOutlinedIcon />
          </IconButton>
          <IconButton
            height={50}
            width={50}
            variant='contained'
            sx={{ 
              color: `${theme.palette.primary.main}`,
              backgroundColor: `${theme.palette.secondary.main}`,
            }}
            onClick={handleBookmarkClick}
          >
            <BookmarkAddOutlinedIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Card>
  )
}

export default RecipeListCardPreview